let appDispatch = () => {};

export const getDispatch = () => appDispatch;
export const setDispatch = (dispatch) => (appDispatch = dispatch);
